import React from 'react';
import { information } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Marine information',
  synonyms: '',
  group: 'standardMarker',
  typeUrl: 'marine-information',
  icon: {
    baseShape: information,
    iconColor: '#fff',
    markerColor: '#906BD9',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'general-services',
    order: 1000,
  },
  standardMarkerOptions: {
    markerType: 'marineInformationMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Marine information',
      itemTitleFunction: (item) => (item && item.title) || 'Marine information',
    },
    creationOptions: {
      menuText: 'Marine information',
      newTitle: 'Marine information',
      titlePlaceholder: 'Title for this marker',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker can be used to share a variety of marine and safety
          information about a particular location.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: true,
    title: 'Marine information',
    description: marker.title,
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
